define('modules/stats/index',['require','exports','module','base/router','./collections/statistics','common/views/dashboard_layout','common/views/404','./views/main','./views/navigation','common/models/date_model','lib/util'],function (require, exports, module) {
  'use strict';

  var Router = require('base/router'),
    StatisticsCollection = require('./collections/statistics'),
    DashboardLayout = require('common/views/dashboard_layout'),
    View404 = require('common/views/404'),
    StatisticView = require('./views/main'),
    NavigationView = require('./views/navigation'),
    DateModel = require('common/models/date_model'),
    util = require('lib/util');

  module.exports = function (moduleManager) {
    var ModuleRouter = Router.extend({
      routes: {
        stats: 'index',
      },
      activateStatisticsTab: function () {
        $('.ed-navlink.active').removeClass('active');
        $('.js-stats').addClass('active');
      },
      index: function () {
        var dateModel = this._cloneDate();
        var statisticsCollection = new StatisticsCollection(
            ([],
            {
              date: dateModel,
            })
          ),
          layout = moduleManager.showInstance(DashboardLayout),
          viewOptions = { collection: statisticsCollection, date: dateModel },
          navigationView = new NavigationView(viewOptions),
          statisticView = new StatisticView(viewOptions);

        layout.$el.find('.ed-subnav').addClass('hidden');

        this.activateStatisticsTab();
        layout.showLoading();

        statisticsCollection.fetch({
          success: function () {
            statisticsCollection.loaded = true;
            layout.$top.show(navigationView);
            layout.$content.show(statisticView);
          },
          error: function () {
            layout.$content.show(new View404());
          },
        });
      },
      _cloneDate: function () {
        var firstDate = new Date();
        firstDate.setDate(1);
        var lastDate = new Date();
        lastDate.setMonth(lastDate.getMonth() + 1, 0);
        return new DateModel({
          from: util.formatDate(firstDate),
          to: util.formatDate(lastDate),
        });
      },
    });

    return new ModuleRouter();
  };
});

